import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ActividadComercial } from "@/shared/types/actividad-comercial";

export interface ActividadComercialEditRequest {
  codigo: string,
  nombre: string,
}

export async function editActividadComercial(id: string, request: ActividadComercialEditRequest): Promise<ActividadComercial> {
  await sleep(1000);
  const response = await api.put(`actividades_comerciales/${id}`, request);
  return response.data;
}

export function useEditActividadComercialMutation(id: string, mutationConfig: MutationConfig<ActividadComercial, ActividadComercialEditRequest> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: request => editActividadComercial(id, request),
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["actividades_comerciales"] });
    },
  })
}

export interface EditActividadComercialMutationProps {
  id: string,
  mutationConfig?: MutationConfig<ActividadComercial, ActividadComercialEditRequest>
  children: (mutationResult: MutationResult<ActividadComercial, ActividadComercialEditRequest>) => ReactNode
}

export function EditActividadComercialMutation({
  id,
  mutationConfig,
  children
}: EditActividadComercialMutationProps) {
  const mutation = useEditActividadComercialMutation(id, mutationConfig);
  return children(mutation);
}
